import axios from 'axios'
import React, { useEffect, useState } from 'react'
import validator from 'validator'
import authService from '../../../Components/Login/auth.service'
import '../../../styles/pages/MenuDireito/modal/modalPessoa.css'
//const uuidv4 = require('uuid/v4')

export default function ModalSubiMenuPessoa() {
  const uuidv4 = window.crypto && window.crypto.randomUUID ? window.crypto.randomUUID() : Date.now().toString(16) + '-' + Math.random().toString(16).slice(2);
  var user = authService.getCurrentUser()
  const [funcoes, setFuncao] = useState([])
  const [grupos, setGrupo] = useState([])
  const [modal, setModal] = useState(false)
  const [errorMessage, setErrorMessage] = useState('')
  const [errorPass, setErrorPass] = useState(false)
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
        '/api/v1/funcao/list/' +
        user[0].IdEmpresa
      )
      .then(response => {
        setFuncao(response.data)
      })
  }, [])
  useEffect(() => {
    axios
      .get(
        process.env.REACT_APP_API_URL +
        '/api/v1/grupoUsuario/list/' +
        user[0].IdEmpresa
      )
      .then(response => {
        setGrupo(response.data)
      })
  }, [])

  const toggleModal = () => {
    setModal(!modal)
  }

  if (modal) {
    document.body.classList.add('active-modal')
  } else {
    document.body.classList.remove('active-modal')
  }
  let newDate = new Date()

  const [campos, setCampos] = useState({
    IdPessoa: '',
    IdUnidade: sessionStorage.IdUnidade,
    IdEmpresa: user[0].IdEmpresa,
    IdFuncao: 0,
    IdGrupoUsuario: 0,
    pesNome: '',
    pesFoto: '',
    pesEmail: '',
    pesSenha: '',
    pesTelefone: '',
    pesCelular: '',
    pesEndereco: '',
    pesAcessoWeb: 1,
    pesAcessoApp: 1,
    pesIdioma: '',
    pesStatus: 1,
    pesObservacoes: '',
    pesCriadoPor: user[0].pesEmail,
    pesCriadoEm: newDate,
    pesAlteradoPor: user[0].pesEmail,
    pesAlteradoEm: newDate,
    pesCodigoGUID: uuidv4
  })
  function handleInputChange(event) {
    if (
      event.target.name === 'pesAcessoWeb' ||
      event.target.name === 'pesAcessoApp' ||
      event.target.name === 'pesStatus'
    ) {
      if (event.target.checked) {
        campos[event.target.name] = 1
      } else {
        campos[event.target.name] = 0
      }
    } else {
      if (event.target.name === 'pesSenha') {
        if (
          validator.isStrongPassword(event.target.value, {
            minLength: 8,
            minLowercase: 1,
            minUppercase: 1,
            minNumbers: 1,
            minSymbols: 1
          })
        ) {
          setErrorMessage('')
          setErrorPass(false)
          if (event.target.value !== campos.confPesSenha) {
            setErrorPass(true)
            setErrorMessage('A confirmação da senha está incorreta')
          } else {
            setErrorMessage('')
            setErrorPass(false)
          }
        } else {
          setErrorPass(true)
          setErrorMessage(
            'A senha não é segura o bastante, a senha deve conter 1 caracter especial, uma letra maiúscula e um número!'
          )
        }
      }
      if (event.target.name === 'confPesSenha') {
        if (event.target.value !== campos.pesSenha) {
          setErrorPass(true)
          setErrorMessage('A confirmação da senha está incorreta')
        } else {
          setErrorMessage('')
          setErrorPass(false)
        }
      }
      campos[event.target.name] = event.target.value
    }
    setCampos(campos)
  }

  function handleFormSubmit(event) {
    event.preventDefault()
    axios
      .post(process.env.REACT_APP_API_URL + '/api/v1/pessoaSemVinculo', campos)
      .then(response => {
        alert(response.data.message)
        window.location.reload()
      })
  }
  return (
    <>
      <button onClick={toggleModal} className="buttonModalPadraoPes">
        Nova Pessoa
      </button>

      {modal && (
        <>
          <div onClick={toggleModal} className="overlay"></div>
          <div className="modalPadraoPessoa-content">
            <div className="cxTituloPadrao">
              <h1>
                Nova Pessoa
                <hr className="hrTitleModal" />
              </h1>
              <button onClick={toggleModal}>X</button>
            </div>
            <form onSubmit={handleFormSubmit}>
              <label>Nome</label>
              <input
                type="text"
                id="fname"
                defaultValue={campos.pesNome}
                name="pesNome"
                onChange={handleInputChange}
              />
              <div className="lineModal">
                <label>Selecione a função:</label>
                <label>Selecione o Idioma:</label>
              </div>
              <div className="lineModal">
                <select
                  name="IdFuncao"
                  type="text"
                  defaultValue={campos.IdFuncao}
                  id="fcontexto"
                  onChange={handleInputChange}
                >
                  <option value="0">Selecione uma Função</option>
                  {funcoes
                    .filter(val => {
                      if (val.fncStatus === 1) {
                        return val
                      }
                    })
                    .map(funcao => (
                      <option value={funcao.IdFuncao}>
                        {funcao.fncDescricao}
                      </option>
                    ))}
                </select>
                <select
                  name="pesIdioma"
                  type="text"
                  defaultValue={campos.pesIdioma}
                  id="fcontexto"
                  onChange={handleInputChange}
                >
                  <option value="">Selecione o Idioma</option>
                  <option value="PORTUGUES">Português</option>
                  <option value="INGLES">Inglês</option>
                  <option value="ESPANHOL">Espanhol</option>
                </select>
              </div>
              <label>Digite o Email:</label>
              <input
                type="text"
                defaultValue={campos.pesEmail}
                id="mail"
                name="pesEmail"
                onChange={handleInputChange}
              />
              <div className="lineModal">
                <label>Digite o Telefone:</label>
                <label>Digite o Celular:</label>
              </div>
              <div className="lineModal">
                <input
                  type="text"
                  defaultValue={campos.pesTelefone}
                  id="fname"
                  name="pesTelefone"
                  onChange={handleInputChange}
                />
                <input
                  type="text"
                  defaultValue={campos.pesCelular}
                  id="fname"
                  name="pesCelular"
                  onChange={handleInputChange}
                />
              </div>
              <div className="lineModal">
                <label>Senha:</label>
                <label>Confirmar Senha:</label>
                <label>Selecione um grupo:</label>
              </div>
              <div className="lineModal">
                <input
                  type="password"
                  defaultValue={campos.pesSenha}
                  id="fname"
                  name="pesSenha"
                  required
                  onChange={handleInputChange}
                />
                <input
                  type="password"
                  id="fname"
                  name="confPesSenha"
                  required
                  onChange={handleInputChange}
                />

                <select
                  name="IdGrupoUsuario"
                  type="text"
                  defaultValue={campos.IdGrupoUsuario}
                  id="fcontexto"
                  onChange={handleInputChange}
                >
                  <option value="0">Selecione um grupo</option>
                  {grupos
                    .filter(val => {
                      if (val.gruStatus === 1) {
                        return val
                      }
                    })
                    .map(grupo => (
                      <option value={grupo.IdGrupoUsuario}>
                        {grupo.gruDescricao}
                      </option>
                    ))}
                </select>
              </div>
              <label>Observações:</label>
              <textarea
                type="text"
                defaultValue={campos.pesObservacoes}
                id="fname"
                name="pesObservacoes"
                row="none"
                maxLength="500"
                onChange={handleInputChange}
              />

              {errorPass === true ? (
                <span className="Alert">{errorMessage}</span>
              ) : (
                <div></div>
              )}

              <div className="caixaSalvarPadrao">
                <div
                  style={{
                    display: 'flex',
                    flexDirection: 'column',
                    height: '70px'
                  }}
                  className="InputAuthorization4"
                >
                  <label>
                    <input
                      name="pesAcessoApp"
                      type="checkbox"
                      defaultChecked={!!campos.pesAcessoApp}
                      onChange={handleInputChange}
                    />
                    <span>Acesso ao APP</span>
                  </label>
                  <label>
                    <input
                      name="pesAcessoWeb"
                      type="checkbox"
                      defaultChecked={!!campos.pesAcessoWeb}
                      onChange={handleInputChange}
                    />
                    <span>Acesso Web</span>
                  </label>
                  <label>
                    <input
                      name="pesStatus"
                      type="checkbox"
                      defaultChecked={!!campos.pesStatus}
                      onChange={handleInputChange}
                    />
                    <span>Status</span>
                  </label>
                </div>
                <button type="submit" disabled={errorPass}>
                  Salvar Registro
                </button>
              </div>
            </form>
          </div>
        </>
      )}
    </>
  )
}
